import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import whatsapp from "../assets/images/icon-customer.svg";
// import telegram from "../assets/images/telegram.png";
// import livechat from "../assets/images/livechat.png";
import { RxCross2 } from "react-icons/rx";
import { isEmpty } from "lodash";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import Modal from "react-bootstrap/Modal";

const Footer = () => {
  const location = useLocation();
  const {
    user,
    showSidebar,
    active,
    setFooterLink,
    displayPopUp,
    setDisplayPopUp,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const [casinoModel, setCasinoModel] = useState(false);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null);
  const [showSupport, setShowSupport] = useState(true);

  const [icon, setIcon] = useState({});
  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getIcon, {
      website: "1xbat.bet",
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const handleTouchEnd = (event) => {
    const touch = event.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);
    if (distance < 5) {
      setCasinoModel(true);
    }
  };

  //   const closePopUp = () => {
  //     localStorage.setItem("seenPopUp", false);
  //     setDisplayPopUp(false);
  //   }

  const handleClick = () => {
    navigate("/refer");
    localStorage.setItem("seenPopUp", false);
    setDisplayPopUp(false);
  };

  const closePopUp = () => {
    localStorage.setItem("seenPopUp", true);

    setDisplayPopUp(false);
  };

  useEffect(() => {
    let returningUser = localStorage.getItem("seenPopUp");

    setDisplayPopUp(!returningUser);
  }, []);

  return (
    <>
      <div className="footer">
        {location?.pathname == "/" && !showSidebar && active == "sports" && (
          <>
            {/* <div className="betbtn1">
              {icon?.whatsappContent &&
                icon?.whatsappContent !== "" &&
                showSupport && (
                  <>
                    <button
                      className="bg-transparent border-0 p-0 close-b"
                      onClick={() => setShowSupport(false)}
                    >
                      <RxCross2 />
                    </button>
                    <div
                      onClick={() => {
                        window.open(
                          "https://wa.me/" + icon?.whatsappContent,
                          "_self"
                        );
                      }}
                    >
                      <img
                        src={
                          icon?.whatsappIcon
                            ? process.env.REACT_APP_API_BASE_URL +
                              icon?.whatsappIcon
                            : whatsapp
                        }
                        alt=""
                      />
                    </div>
                  </>
                )}

              {icon?.telegramContent && icon?.telegramContent !== "" && (
              <div
                onClick={() => {
                  
                  window.open(icon?.telegramContent, "_self");
                }}>
                <img
                  src={icon?.telegramIcon?process.env.REACT_APP_API_BASE_URL + icon?.telegramIcon:telegram}
                  alt=""
                />
              </div>
            )}{" "}
            {icon?.livechatContent && icon?.livechatContent !== "" && location?.pathname == "/" && (
              <div
                onClick={() => {
                  window.open(icon?.livechatContent, "_self");
                }}
              >
                <img
                  src={icon?.livechatIcon?process.env.REACT_APP_API_BASE_URL + icon?.livechatIcon:livechat}
                  alt=""
                />
              </div>
            )}

               {location?.pathname == "/" && (
              <noscript>
                <a
                  href="https://www.livechat.com/chat-with/17022978/"
                  rel="nofollow"
                >
                  Chat with us
                </a>
                , powered by{" "}
                <a
                  href="https://www.livechat.com/?welcome"
                  rel="noopener nofollow"
                  target="_blank"
                >
                  LiveChat
                </a>
              </noscript>
            )}
            </div> */}
            <div className="betbtn2">
              {!isEmpty(user) && (
                <div
                  onClick={() => {
                    window.open(
                      icon?.whatsappContent
                        ? "https://wa.me/" + icon?.whatsappContent
                        : "https://wa.me/+971566258679",
                      "_self"
                    );
                  }}
                  className="livechat-bg blinkPulse"
                >
                  <TfiHeadphoneAlt style={{ color: `#fff` }} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {displayPopUp && (
        <Modal
          centered
          show={true}
          onHide={closePopUp}
          
        >
          <Modal.Header
            closeButton
            className="mobile-singup-bonus-header"
          ></Modal.Header>
          <Modal.Body className="mobile-singup-bonus">
            <img
              src="../assets/images/p-banner.webp"
              onClick={handleClick}
            ></img>
            {/* <div className="pop-title ">
            <h3>শুধু মাত্র কোম্পানি এফিলেট ইউজাররা গ্রহণযোগ্য।</h3>
          </div> */}
           <div className="pop-inner content-style promotion ng-tns-c3252189-0 ng-star-inserted">
            <ul className="popul">
              <li >
                🏏ইন্ডিয়ান প্রিমিয়ার লীগ ধামাকা অফার 🔥{" "}
              </li>
              <li >
                🎁প্রথম পুরস্কার 𝗧𝗢𝗬𝗢𝗧𝗔 (কার)🚘{" "}
              </li>
              <li >🎁দ্বিতীয় পুরস্কার 𝗥𝟭𝟱 (বাইক)🏍</li>
              <li >
                🎁তৃতীয় পুরস্কার 𝟯 ভরি সোনার চেন ।{" "}
              </li>
              <li >
                👉4 থেকে 10 জন ইউজার কে নগদ ক্যাশ দেওয়া হবে 25,000 টাকা করে।
              </li>
              <li >
                👉11 থেকে 25 জন ইউজার কে নগদ ক্যাশ 15,000 টাকা করে দেওয়া হবে।
              </li>
              <li >
                👉26 থেকে 50 জন ইউজার কে ইউজার আইডিতে 5,000 পয়েন্টস করে দেওয়া
                হবে।
              </li>
              <li >
                ✅প্রত্যেক ইউজার লটারীর মাধ্যমে নির্বাচিত হবে।
              </li>
              <li  >
                ✨ শর্তাবলী ::{" "}
              </li>
              <li >
                ১. প্রথম, দ্বিতীয়, তৃতীয় পুষ্কারের এর জন্য ইউজার কে পুরা IPL
                জুড়ে 10 লাখ ডিপোজিট trun ওভার 25 লাখ হতে হবে।।{" "}
              </li>
              <li >
                ২. 4 th থেকে 10 th এর ইউজার কে পুরা IPL জুড়ে 3 লাখ ডিপোজিট trun
                over 5 লাখ হতে হবে।
              </li>
              <li >
                ৩. 11 Th থেকে 25 Th এর জন্য ইউজার কে পুরা IPL জুড়ে 2 লাখ
                ডিপোজিট Trun over 3 লাখ হতে হবে।
              </li>
              <li >
                ৪. 26 th থেকে 50 th এর জন্য ইউজার কে পুরা IPL জুড়ে 1 লাখ
                ডিপোজিট Trun over&nbsp;2&nbsp;লাখ&nbsp;হতে&nbsp;হবে
              </li>
            </ul>
            </div>
          </Modal.Body>

          {/* <Modal.Footer>
            
          </Modal.Footer> */}
        </Modal>
      )}
    </>
  );
};

export default Footer;
